<template>
  <vue-html2pdf
    :show-layout="false"
    :float-layout="false"
    :enable-download="false"
    :preview-modal="false"
    :filename="`quote_${item.id}`"
    :pdf-quality="2"
    :manual-pagination="true"
    pdf-format="a4"
    ref="html2Pdf"
    @beforeDownload="beforeDownload($event)"
  >
    <section slot="pdf-content">
      <section class="pdf-item">
        <h6>Bid #{{ item.id }}</h6>
        <hr />
        <div>
          <table width="100%" cellpadding="10">
            <tr>
              <td>
                <img src="/static/assets/ling-logo.png" height="80" />
              </td>
              <td class="text-right p-10">
                <img v-if="isPaid" src="/static/assets/paid.png" height="80" />
              </td>
            </tr>
          </table>

          <table width="100%" cellpadding="10">
            <tr>
              <td
                class="text-left p-10"
                style="
                  border: 5px solid #cfcfcf;
                  padding: 20px;
                  vertical-align: top;
                "
              >
                <h3>FROM</h3>

                <company-address />
              </td>
              <td
                class="text-left p-10"
                style="
                  border: 5px solid #cfcfcf;
                  padding: 20px;
                  vertical-align: top;
                "
              >
                <h3>TO</h3>
                <company-address :item="client" />
              </td>
            </tr>
          </table>

          <div class="mt-5">
            <table width="100%" cellpadding="10">
              <tr>
                <td width="33%" class="text-left">
                  <h2>Bid #{{ item.id }}</h2>
                </td>
                <td width="33%" class="text-center">
                  <b>Bid Date: {{ item.termStartDate | formatDate }}</b>
                </td>
                <td width="33%" class="text-right">
                  <b>Due Date: {{ item.dueDate | formatDate }}</b>
                </td>
              </tr>
            </table>
          </div>

          <table
            width="100%"
            border="0"
            cellpadding="0"
            cellspacing="0"
            class="pdf"
          >
            <thead>
              <tr>
                <th>No</th>
                <th>Item</th>
                <th>Description</th>
                <th>Qty</th>
                <th v-show="isAdmin">Cost</th>
                <th>Price</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in item.lineItems" :key="index">
                <td class="text-left" width="5">{{ ++index }}</td>
                <td class="text-left">{{ item.title }}</td>
                <td class="text-left">{{ item.description }}</td>
                <td class="text-left">{{ item.quantity }}</td>
                <td class="text-left" v-show="isAdmin">
                  {{ item.cost | formatPrice }}
                </td>
                <td class="text-left">
                  {{ item.price | formatPrice }}
                </td>
                <td class="text-left">
                  {{
                    (parseFloat(item.price) * parseFloat(item.quantity))
                      | formatPrice
                  }}
                </td>
              </tr>
            </tbody>

            <tfoot>
              <tr v-show="totalTax > 0">
                <td :colspan="isAdmin ? 6 : 5" class="text-right">
                  <h5>Total Tax:</h5>
                </td>
                <td class="text-left">
                  {{ totalTax | formatPrice }}
                </td>
              </tr>
              <tr>
                <td :colspan="isAdmin ? 6 : 5" class="text-right">
                  <h5>Total:</h5>
                </td>
                <td class="text-left">
                  {{ (totalSub + totalTax) | formatPrice }}
                </td>
              </tr>

              <tr>
                <td :colspan="isAdmin ? 6 : 5" class="text-right">
                  <h5>Grant Total Due:</h5>
                </td>
                <td class="text-left">
                  {{ totalGrandDue | formatPrice }}
                </td>
              </tr>
              <tr v-show="isAdmin">
                <td :colspan="isAdmin ? 6 : 5" class="text-right">
                  <h5>Total Cost:</h5>
                </td>
                <td class="text-left">
                  {{ totalCost | formatPrice }}
                </td>
              </tr>
              <tr v-show="isAdmin">
                <td :colspan="isAdmin ? 6 : 5" class="text-right">
                  <h5>Total Profit:</h5>
                </td>
                <td class="text-left">
                  {{ totalProfit | formatPrice }}
                </td>
              </tr>
              <tr v-show="isAdmin">
                <td class="text-right" colspan="4">
                  <h5>Parts:</h5>
                </td>
                <td class="text-left">
                  {{ totalPart | formatPrice }}
                </td>
                <td class="text-right">
                  <h5>Income:</h5>
                </td>
                <td class="text-left">
                  {{ incomePart | formatPrice }}
                </td>
              </tr>
              <tr v-show="isAdmin">
                <td class="text-right" colspan="4">
                  <h5>Labor:</h5>
                </td>
                <td class="text-left">
                  {{ totalLabor | formatPrice }}
                </td>
                <td class="text-right">
                  <h5>Income:</h5>
                </td>
                <td class="text-left">
                  {{ incomeLabor | formatPrice }}
                </td>
              </tr>
            </tfoot>
          </table>
          <div class="mt-5 p-5">
            <table width="100%" cellpadding="10">
              <tr>
                <td>
                  Thank you for your business.
                  <br />
                  <b
                    >If paying by check, Please make your check payable to
                    {{ company.companyName }}</b
                  >
                </td>
              </tr>
            </table>
          </div>
        </div>
      </section>
    </section>
  </vue-html2pdf>
</template>


<script>
import { mapActions, mapState } from "vuex";
import formatterMixin from "src/mixins/formatterMixin";
import VueHtml2pdf from "vue-html2pdf";
import CompanyAddress from "components/CompanyAddress";

export default {
  props: {
    isAdmin: Boolean,
    item: Object,
  },
  mixins: [formatterMixin],
  components: {
    VueHtml2pdf,
    CompanyAddress,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      quote: (state) => state.quote,
      alert: (state) => state.alert,
      account: (state) => state.account,
      client: (state) => state.client.single,
      company: (state) => state.account.data.account,
    }),

    isPaid() {
      return this.item.status == "paid" || this.item.status == "Paid";
    },

    toClient() {
      let words = [];
      const {
        companyName,
        address,
        city,
        state,
        zipcode,
        email,
        phoneNumber,
      } = this.client.single;

      if (companyName) {
        words.push(`<b>${companyName}</b>`);
      }

      if (address || city || state || zipcode) {
        words.push(`${address} ${city} ${state} ${zipcode}`);
      }

      if (phoneNumber) {
        words.push(`Mobile: ${phoneNumber}`);
      }

      if (email) {
        words.push(email);
      }
      return words.join("<br />");
    },

    totalSub() {
      let total = 0;
      if (this.item && this.item.lineItems && this.item.lineItems.length > 0) {
        this.item.lineItems.map((item) => {
          total += parseFloat(item.price) * parseFloat(item.quantity);
        });
      }
      return total;
    },

    totalTax() {
      return this.item.quoteTaxTotal;
    },

    totalCost() {
      let total = 0;
      if (this.item && this.item.lineItems && this.item.lineItems.length > 0) {
        this.item.lineItems.map((item) => {
          total += parseFloat(item.cost) * parseFloat(item.quantity);
        });
      }
      return total;
    },

    totalProfit() {
      return this.totalSub - this.totalCost;
    },

    totalGrandDue() {
      if (this.item.status === "Overdue") {
        return this.item.quoteTotal;
      }
      return 0;
    },

    totalPart() {
      let total = 0;
      if (this.item && this.item.lineItems && this.item.lineItems.length > 0) {
        this.item.lineItems
          .filter((item) => item.itemType == "Parts")
          .map((item) => {
            total += this.subTotalPrice(item);
          });
      }
      return total;
    },

    totalCostPart() {
      let total = 0;
      if (this.item && this.item.lineItems && this.item.lineItems.length > 0) {
        this.item.lineItems
          .filter((item) => item.itemType == "Parts")
          .map((item) => {
            total += this.subTotalCost(item);
          });
      }
      return total;
    },

    incomePart() {
      return this.totalPart - this.totalCostPart;
    },

    totalLabor() {
      let total = 0;
      if (this.item && this.item.lineItems && this.item.lineItems.length > 0) {
        this.item.lineItems
          .filter((item) => item.itemType == "Labor")
          .map((item) => {
            total += this.subTotalPrice(item);
          });
      }
      return total;
    },

    totalCostLabor() {
      let total = 0;
      if (this.item && this.item.lineItems && this.item.lineItems.length > 0) {
        this.item.lineItems
          .filter((item) => item.itemType == "Labor")
          .map((item) => {
            total += this.subTotalCost(item);
          });
      }
      return total;
    },

    incomeLabor() {
      return this.totalLabor - this.totalCostLabor;
    },
  },
  watch: {
    async item(n, o) {
      if (n.clientId) {
        await this.getClientById(this.item.clientId);
      }
      if (JSON.stringify(n)!==JSON.stringify(o)) {
          this.generateReport();
      }
    },
  },
  methods: {
    ...mapActions({
      getClientById: "client/getById",
    }),
    subTotalPrice(item) {
      return parseFloat(item.quantity) * parseFloat(item.price);
    },

    subTotalCost(item) {
      return parseFloat(item.quantity) * parseFloat(item.cost);
    },

    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    closeDelete() {
      this.$store.dispatch("alert/clear");
      this.$emit("onClosed");
    },

    async beforeDownload({ html2pdf, pdfContent }) {
      await html2pdf()
        .from(pdfContent)
        .toImg()
        .get("img")
        .then((img) => {
          this.$emit("onImg", img);
        });
    },
  },

  async mounted() {
    this.generateReport();
  },
};
</script>